import styled, { keyframes } from 'styled-components';
import { ColorTheme, TextTheme, ShadowTheme, BorderRadiusTheme } from '../globaStyledComponents/globalStyledComponentsStyling';

const slideIn = keyframes`
    from {
        transform: translateY(100%);
        opacity: 0;
    }
    to {
        transform: translateY(0);
        opacity: 1;
    }
`;

const slideOut = keyframes`
    from {
        transform: translateY(0);
        opacity: 1;
    }
    to {
        transform: translateY(100%);
        opacity: 0;
    }
`;

export const ToastContainer = styled.div`
    position: fixed;
    bottom: 24px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 9999;
    width: fit-content;
    padding: 0 24px;
    pointer-events: none;
`;

export const ToastWrapper = styled.div<{ type: 'error' | 'success' | 'info' }>`
    background: ${ColorTheme.Black.color};
    padding: 16px;
    border-radius: ${BorderRadiusTheme.radius_12.borderRadius};
    box-shadow: ${ShadowTheme.shadow_300.boxShadow};
    animation: ${slideIn} 125ms ease-out forwards;
    pointer-events: auto;

    &.closing {
        animation: ${slideOut} 0.3s ease-in forwards;
    }
`;

export const ToastMessage = styled.p`
    margin: 0;
    font-size: ${TextTheme.sans_400_semi.fontSize};
    font-family: ${TextTheme.sans_400_semi.fontFamily};
    line-height: ${TextTheme.sans_400_semi.lineHeight};
    color: ${ColorTheme.White.color};
    text-align: center;
    white-space: nowrap;
`; 